export const intRule = (val: string) => !!(val && val.match(/^[0-9]+$/)) || 'Wartość musi być liczbą';